/**
 * tasksense-scheduler-service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { CheckAvailabilityRequest } from '../model/checkAvailabilityRequest';
// @ts-ignore
import { CheckAvailabilityResponse } from '../model/checkAvailabilityResponse';
// @ts-ignore
import { CronSchedulerDefinition } from '../model/cronSchedulerDefinition';
// @ts-ignore
import { DailySchedulerDefinition } from '../model/dailySchedulerDefinition';
// @ts-ignore
import { DescribeRequest } from '../model/describeRequest';
// @ts-ignore
import { Event } from '../model/event';
// @ts-ignore
import { HourlySchedulerDefinition } from '../model/hourlySchedulerDefinition';
// @ts-ignore
import { MonthlySchedulerDefinition } from '../model/monthlySchedulerDefinition';
// @ts-ignore
import { OnceSchedulerDefinition } from '../model/onceSchedulerDefinition';
// @ts-ignore
import { SampleEventCalculationRequestPayload } from '../model/sampleEventCalculationRequestPayload';
// @ts-ignore
import { SchedulerDefinition } from '../model/schedulerDefinition';
// @ts-ignore
import { WeeklySchedulerDefinition } from '../model/weeklySchedulerDefinition';
// @ts-ignore
import { YearlySchedulerDefinition } from '../model/yearlySchedulerDefinition';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class SchedulerControllerService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @param checkAvailabilityRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkAvailability(checkAvailabilityRequest: CheckAvailabilityRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CheckAvailabilityResponse>;
    public checkAvailability(checkAvailabilityRequest: CheckAvailabilityRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CheckAvailabilityResponse>>;
    public checkAvailability(checkAvailabilityRequest: CheckAvailabilityRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CheckAvailabilityResponse>>;
    public checkAvailability(checkAvailabilityRequest: CheckAvailabilityRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (checkAvailabilityRequest === null || checkAvailabilityRequest === undefined) {
            throw new Error('Required parameter checkAvailabilityRequest was null or undefined when calling checkAvailability.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/check-availability`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CheckAvailabilityResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: checkAvailabilityRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param schedulerDefinitionCronSchedulerDefinitionDailySchedulerDefinitionHourlySchedulerDefinitionMonthlySchedulerDefinitionOnceSchedulerDefinitionWeeklySchedulerDefinitionYearlySchedulerDefinition 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public describe(schedulerDefinitionCronSchedulerDefinitionDailySchedulerDefinitionHourlySchedulerDefinitionMonthlySchedulerDefinitionOnceSchedulerDefinitionWeeklySchedulerDefinitionYearlySchedulerDefinition: SchedulerDefinition | CronSchedulerDefinition | DailySchedulerDefinition | HourlySchedulerDefinition | MonthlySchedulerDefinition | OnceSchedulerDefinition | WeeklySchedulerDefinition | YearlySchedulerDefinition, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public describe(schedulerDefinitionCronSchedulerDefinitionDailySchedulerDefinitionHourlySchedulerDefinitionMonthlySchedulerDefinitionOnceSchedulerDefinitionWeeklySchedulerDefinitionYearlySchedulerDefinition: SchedulerDefinition | CronSchedulerDefinition | DailySchedulerDefinition | HourlySchedulerDefinition | MonthlySchedulerDefinition | OnceSchedulerDefinition | WeeklySchedulerDefinition | YearlySchedulerDefinition, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public describe(schedulerDefinitionCronSchedulerDefinitionDailySchedulerDefinitionHourlySchedulerDefinitionMonthlySchedulerDefinitionOnceSchedulerDefinitionWeeklySchedulerDefinitionYearlySchedulerDefinition: SchedulerDefinition | CronSchedulerDefinition | DailySchedulerDefinition | HourlySchedulerDefinition | MonthlySchedulerDefinition | OnceSchedulerDefinition | WeeklySchedulerDefinition | YearlySchedulerDefinition, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public describe(schedulerDefinitionCronSchedulerDefinitionDailySchedulerDefinitionHourlySchedulerDefinitionMonthlySchedulerDefinitionOnceSchedulerDefinitionWeeklySchedulerDefinitionYearlySchedulerDefinition: SchedulerDefinition | CronSchedulerDefinition | DailySchedulerDefinition | HourlySchedulerDefinition | MonthlySchedulerDefinition | OnceSchedulerDefinition | WeeklySchedulerDefinition | YearlySchedulerDefinition, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (schedulerDefinitionCronSchedulerDefinitionDailySchedulerDefinitionHourlySchedulerDefinitionMonthlySchedulerDefinitionOnceSchedulerDefinitionWeeklySchedulerDefinitionYearlySchedulerDefinition === null || schedulerDefinitionCronSchedulerDefinitionDailySchedulerDefinitionHourlySchedulerDefinitionMonthlySchedulerDefinitionOnceSchedulerDefinitionWeeklySchedulerDefinitionYearlySchedulerDefinition === undefined) {
            throw new Error('Required parameter schedulerDefinitionCronSchedulerDefinitionDailySchedulerDefinitionHourlySchedulerDefinitionMonthlySchedulerDefinitionOnceSchedulerDefinitionWeeklySchedulerDefinitionYearlySchedulerDefinition was null or undefined when calling describe.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/describe`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<string>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: schedulerDefinitionCronSchedulerDefinitionDailySchedulerDefinitionHourlySchedulerDefinitionMonthlySchedulerDefinitionOnceSchedulerDefinitionWeeklySchedulerDefinitionYearlySchedulerDefinition,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param sampleEventCalculationRequestPayload 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public next(sampleEventCalculationRequestPayload: SampleEventCalculationRequestPayload, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<Event>>;
    public next(sampleEventCalculationRequestPayload: SampleEventCalculationRequestPayload, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<Event>>>;
    public next(sampleEventCalculationRequestPayload: SampleEventCalculationRequestPayload, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<Event>>>;
    public next(sampleEventCalculationRequestPayload: SampleEventCalculationRequestPayload, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sampleEventCalculationRequestPayload === null || sampleEventCalculationRequestPayload === undefined) {
            throw new Error('Required parameter sampleEventCalculationRequestPayload was null or undefined when calling next.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/sample`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<Event>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: sampleEventCalculationRequestPayload,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
